import React, { useState, useEffect } from 'react';
import { useJWTAuth } from '../auth/JWTAuthContext';
import { useAccountLinking } from '../auth/useAccountLinking';
import UsernamePrompt from './UsernamePrompt';

const AuthManager = ({ children }) => {
  const { login: jwtLogin, isAuthenticated } = useJWTAuth();
  const { user: accountUser } = useAccountLinking();
  const [showUsernamePrompt, setShowUsernamePrompt] = useState(false);
  const [pendingWalletAddress, setPendingWalletAddress] = useState(null);

  // Check if user needs to set username when account linking user changes
  // NOTE: This is now handled directly in WalletConnectionModal for better UX
  useEffect(() => {
    const checkUsernameRequirement = async () => {
      console.log('🔍 [AuthManager] Effect triggered (disabled - handled in WalletConnectionModal):', {
        hasAccountUser: !!accountUser,
        isJWTAuthenticated: isAuthenticated(),
        accountUser: accountUser ? {
          id: accountUser.id,
          wallet_address: accountUser.wallet_address
        } : null
      });

      // Skip automatic username checking - this is now handled in WalletConnectionModal
      console.log('ℹ️ [AuthManager] Skipping automatic username check - handled in WalletConnectionModal');
    };

    checkUsernameRequirement();
  }, [accountUser, isAuthenticated, jwtLogin]);

  const handleUsernameSubmit = async (username) => {
    console.log('👤 [AuthManager] Username submit called:', {
      username,
      pendingWalletAddress
    });

    if (!pendingWalletAddress) {
      throw new Error('No pending wallet address');
    }

    try {
      console.log('🔍 [AuthManager] Calling JWT login with username...');
      const result = await jwtLogin(pendingWalletAddress, username);
      console.log('🔍 [AuthManager] Username submit result:', result);
      
      if (result.success) {
        console.log('✅ [AuthManager] Username set successfully');
        setShowUsernamePrompt(false);
        setPendingWalletAddress(null);
      } else {
        throw new Error(result.error || 'Failed to set username');
      }
    } catch (error) {
      console.error('❌ [AuthManager] Error setting username:', error);
      throw error;
    }
  };

  const handleUsernamePromptClose = () => {
    setShowUsernamePrompt(false);
    setPendingWalletAddress(null);
  };

  return (
    <>
      {children}
      <UsernamePrompt
        isOpen={showUsernamePrompt}
        onClose={handleUsernamePromptClose}
        onSubmit={handleUsernameSubmit}
        walletAddress={pendingWalletAddress}
      />
    </>
  );
};

export default AuthManager;
